import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setRetryBudget } from "./api";
import type { RetryBudgetResponse, SetRetryBudgetRequest } from "./api";

// PUT бюджета организации. Эффективный бюджет репозиториев без
// собственного значения зависит от организации, поэтому на успех
// инвалидируем и настройки репозиториев.
export function useSetRetryBudget(): ReturnType<
  typeof useMutation<RetryBudgetResponse, Error, SetRetryBudgetRequest>
> {
  const queryClient = useQueryClient();
  return useMutation<RetryBudgetResponse, Error, SetRetryBudgetRequest>({
    mutationFn: (body) => setRetryBudget(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["retryBudget"] });
      void queryClient.invalidateQueries({
        queryKey: ["repositorySettings"],
      });
    },
  });
}
